import React from 'react';
import { Table } from 'antd';

const DataTable = ({ dataSource, columns, ...rest }) => {
  return (
    <div className="custom-table mb-4">
      <Table
        size="middle"
        tableLayout="fixed"
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        {...rest}
      />
    </div>
  );
};

export default DataTable;
